import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import jwtDecode from 'jwt-decode';
import { BehaviorSubject, Observable } from 'rxjs';
import { Login } from 'src/app/shared/interfaces/login';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private _HttpClient: HttpClient, private _Router: Router) {
    if (localStorage.getItem('userToken') != null) {
      this.saveCurrentUser();
      this.saveUserData();
    }
  }
  userData: any;
  dataUser = new BehaviorSubject(null);
  currentUser = new BehaviorSubject(null);
  saveUserData() {
    let token_api: any = localStorage.getItem('userToken');
    let decodedToken: any = jwtDecode(token_api)
    this.userData = decodedToken;
  }

  saveCurrentUser() {
    let token_api: any = localStorage.getItem('userToken');
    this.currentUser.next(token_api);
  }
  saveResetPassHash() {
    let token_api: any = localStorage.getItem('ResetPassHash');
    this.currentUser.next(token_api);
  }
  setUserrofile(data: any) {
    localStorage.setItem('userData', JSON.stringify(data));
    this.currentUser.next(data);
  }

  getUserProfile() {
    if (this.currentUser.value) {
      return this.currentUser.value;
    } else {
      let userData: any = localStorage.getItem('userData');
      if (userData) {
        this.currentUser.next(JSON.parse(userData));
        return this.currentUser.value;
      }
      return null;
    }
  }

  getToken() {
    return window.localStorage.getItem('userToken')!;
  }
  getRefreshToken() {
    return window.localStorage.getItem('refresh_token')!;
  }

  login(formData: any): Observable<Login[]> {
    return this._HttpClient.post<Login[]>(environment.baseUrl + 'auth/login', formData);
  }


  resetUserProfile() {
    this.currentUser.next(null);
    localStorage.removeItem('userData')
  }

  logout() {
    this.currentUser.next(null);
    localStorage.removeItem('userData');
    localStorage.removeItem('userToken');
    localStorage.removeItem('refresh_token');
    sessionStorage.clear();
    window.location.reload();
    this._Router.navigate(['/login']);
  }

  RefreshToken(): Observable<any> {
    let ref_token: any = localStorage.getItem('refresh_token');
    let header = {
      'Authorization': `Bearer ${ref_token}`
    }
    let requestHeaders = new HttpHeaders(header)
    return this._HttpClient.post<any>(environment.baseUrl + 'auth/refresh', { headers: requestHeaders });
  }

  retunHeaderToken() {
    let { token_api }: any = this.getUserProfile();
    let header = {
      headers: {
        'Authorization': `Bearer ${token_api}`
      }
    }
    return header;
  }
}
